import { IMasterSync } from './IMasterSync';
import { P00039Sync } from './edro/P00039Sync';
import { Buffer } from 'buffer';

export function getSyncManagerByModelIdentifierAndVersion(
  modelIdentifier: string,
  versionFirmware: number,
): IMasterSync | null {
  console.log('versionFirmware', versionFirmware);

  //Note : La dernier version connue doit toujours être >=, pour eviter de devoir déployer à nouveau l'application dans le cas d'une mise à jour du P00039 sans modification de l'interface

  if (modelIdentifier === 'P00039' && versionFirmware <= 3) {
    return new P00039Sync(versionFirmware);
  } else if (modelIdentifier === 'P00039' && versionFirmware == 4) {
    return new P00039Sync(versionFirmware);
  } else if (modelIdentifier === 'P00039' && versionFirmware == 5) {
    return new P00039Sync(versionFirmware);
  } else if (modelIdentifier === 'P00039' && versionFirmware == 6) {
    return new P00039Sync(versionFirmware);
  } else if (modelIdentifier === 'P00039' && versionFirmware == 7) {
    return new P00039Sync(versionFirmware);
  } else if (modelIdentifier === 'P00039' && versionFirmware == 8) {
    return new P00039Sync(versionFirmware);
  } else if (modelIdentifier === 'P00039' && versionFirmware < 12) {
    return new P00039Sync(versionFirmware);
  } else if (modelIdentifier === 'P00077' && versionFirmware < 12) {
    return new P00039Sync(versionFirmware);
  } else if (modelIdentifier === 'P00039' && versionFirmware >= 12) {
    return new P00039Sync(versionFirmware);
  } else if (modelIdentifier === 'P00077' && versionFirmware >= 12) {
    return new P00039Sync(versionFirmware);
  }

  return null;
}

//Cette fonction n'est censé jamais changer tous les produits posséderont un dt avec le maitre en 0100
export function getFirmwareVersionFromBackup(pool: any) {
  const backup = JSON.parse(pool.backup);

  try {
    if (backup && backup.dt && backup.dt['0100']) {
      return Buffer.from(backup.dt['0100'].toString(), 'hex').readUInt8(15);
    }
  } catch (e) {
    console.log(e);
    return 0;
  }

  return 0;
}
